import styled, { keyframes } from 'styled-components';

export const HeroContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.33);
  height: calc(100vh - 136px);
  width: calc(100% - 32px);
  margin: 0 auto;
  padding: 16px;
  overflow: hidden;
  border-radius: 24px;
  position: relative;

  @media (max-width: 1180px) {
    border-radius: 0px;
    height: 100%;
    width: 100%;
    background-color: transparent;
    padding: 0;
  }
`;

export const HeroFlexWrapper = styled.div`
  max-width: 1440px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  position: relative;

  @media (max-width: 1180px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 32px 16px 0px;
  }
`;

export const HeroLeftSection = styled.div`
  width: 100%;
  max-width: 560px;
  @media (max-width: 1180px) {
    max-width: 100%;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SignupFormWrapper = styled.div`
    width: 100%;
    max-width: 480px;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #cbd5e1;
    position: relative;
    .authFormContainer {
      width: 100% !important;
    }

    @media (max-width: 1180px) {
      max-width: 100%;
    }

    .getOTPButtonStyles,.verify-otp-button-container{
      width: 100%;
    }

    .resend-otp-button-away-from-timer {
      color: #991b1b !important;
    }
    .getOTPFieldButtonClassName {
      height: 36px;
      width: 108px;
      margin-top: 24px;
      margin-left: 8px;
      color: #991b1b !important;
      background-color: #ffffff !important;
      border: 1px solid #991b1b !important;
      * {
        pointer-events: none;
      }
      @media screen and (max-width: 768px) {
        margin: 0px 0px 6px;
        width: 100%;
      }
    }

    .verify-otp-button-container {
      background-color: #991b1b !important;
      color: #ffffff !important;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px !important;

      @media screen and (max-width: 768px) {
        width: 100% !important;
      }
    }

    @supports not (min-height: 100dvh) {
      min-height: 100vh;
    }

    @media screen and (max-width: 768px) {
      flex-direction: column;
      padding: 24px 16px;

      .otp-input-box-containers {
        display: flex !important;
        -webkit-box-pack: justify !important;
        justify-content: space-between !important;
      }
      .otp-input {
        margin-right: unset !important;
        height: unset !important;
        width: unset !important;
        max-width: 40px !important;
      }
    }
    @media screen and (max-width: 1199px) {
      

      justify-content: unset;

      @supports not (min-height: 100dvh) {
        min-height: calc(100vh - 134px);
      }
  `;

export const HeroMainTitle = styled.div`
  font-family: Satoshi;
  font-weight: 500;
  font-size: 42px;
  line-height: 60px;
  letter-spacing: 0%;
  color: #fff1c6;
  margin-bottom: 16px;
  @media (max-width: 1180px) {
    font-size: 32px;
    line-height: 48px;
    width: 100%;
    margin-bottom: 16px;
  }
`;

export const HeroSubTitle = styled.div`
  color: #fff1c6;
  margin-top: 0;
  margin-bottom: 0;
  font-family: Satoshi, Arial, sans-serif;
  font-size: 28px;
  font-weight: 500;
  line-height: 32px;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 10px;
  }
`;

export const HeroDescription = styled.div`
  font-family: Satoshi;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #fff1c6;
`;

export const FeatureListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const SignupFormHeading = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #334155;
`;

export const ScrollDownButton = styled.button`
  display: none;

  @media (min-width: 1180px) {
    height: 32px;
    border-radius: 50%;
    width: 32px;
    background-color: #991b1b;
    margin: -16px auto 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    cursor: pointer;
  }
`;

const fadeAnimation = keyframes`
  0% { opacity: 0; }
  15% { opacity: 1; }
  30% { opacity: 1; }
  60% { opacity: 0; }
  100% { opacity: 0; }
`;

export const BackgroundSlideshow = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  overflow: hidden;
  --duration: ${({ duration }) => duration}s;
  --slides: ${({ slides }) => slides};

  &::before {
    content: '';
    background-color: #000000a8;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 1;

    @media (max-width: 1180px) {
      height: calc(100% - 162px);
    }
  }
`;

const BackgroundSlideImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  animation: ${fadeAnimation} var(--duration) infinite;
  transition: opacity 1s ease-in-out;

  @media (max-width: 1180px) {
    height: calc(100% - 162px);
  }
`;

interface BackgroundSlideProps {
  imageUrl: string;
  animationDelay: number;
}

export const BackgroundSlide = styled(
  BackgroundSlideImage
)<BackgroundSlideProps>`
  background-image: url(${(props) => props.imageUrl});
  ${(props) =>
    props.animationDelay > 0
      ? `animation-delay: calc(var(--duration) / var(--slides) * ${props.animationDelay});`
      : 'animation-delay: calc(0s);'}
`;

export const FeatureItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
`;

export const FeatureText = styled.p`
  font-family: Satoshi;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #fff1c6;
`;

export const WhirlArrowContainer = styled.div`
  display: none;
  @media (min-width: 1180px) {
    display: block;
    position: absolute;
    bottom: -150px;
    right: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
`;
